import { useEffect } from "react";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import About from "@/components/landing/About";
import Portfolio from "@/components/landing/Portfolio";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";

export default function Landing() {
  useEffect(() => {
    document.title = "ASELU Investment Growth Limited — Powering Africa's Future";
  }, []);

  return (
    <div className="min-h-screen bg-[hsl(var(--bg))]" data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Portfolio />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
